import * as BABYLON from 'babylonjs';
import {dfy_menu} from './dfySetting.js';
import * as GUI from 'babylonjs-gui';
export class Probe{
    constructor(gameScene,size,pos,name){
        this.scene=gameScene;
        this.mesh=BABYLON.Mesh.CreateBox(name, size/10,this.scene);
        this.mesh.scaling.y=10;
        this.mesh.position=pos;
        this.position=this.mesh.position;
        this.observer=this.scene.onBeforeRenderObservable.add(()=>this.checkbottom(new BABYLON.Vector3(0,-1,0),500));
        this.removeObserver();
        
    }
    checkbottom(directionRay,deep){
        //console.log("hitting")
        let origin = this.mesh.position;
	
        //let forward = new BABYLON.Vector3(0,-1,0);
        let forward = directionRay;		
	    forward = this.vecToLocal(forward, this.mesh);
	
	    let direction = forward.subtract(origin);
	    direction = BABYLON.Vector3.Normalize(direction);
	
	    let length = deep;
	
	    let ray = new BABYLON.Ray(origin, direction, length);

        let hit = this.scene.pickWithRay(ray, (mesh)=>{
            if (mesh === this.mesh || mesh.name === "indicator"){
                return false;
            }
            return true;
        });
        
        if (hit.pickedMesh){
            this.mesh.position.y =directionRay.y<0?hit.pickedPoint.y+0.1:hit.pickedPoint.y-0.1;
            //console.log("hit:"+hit.pickedMesh.name+" locate: "+hit.pickedPoint.y+";"+this.mesh.name);
        }
    }
    vecToLocal(vector, mesh){
        mesh.computeWorldMatrix(true); 
        let m = mesh.getWorldMatrix();
        let v = BABYLON.Vector3.TransformCoordinates(vector, m);
		return v;		 
    }
    dispose(){
        this.mesh.dispose();
        //this.scene=null;
        delete this;
    }
    removeObserver()
    {
        if(this.observer!==null){
            setTimeout(()=>this.scene.onBeforeRenderObservable.remove(this.observer), 1000);
        }
        
    }
}

export class Rope{
    constructor(scene,shapePoints,color,name){
        this.scene=scene;
        this.mesh=BABYLON.MeshBuilder.CreateLines(name, {points: shapePoints}, this.scene); 
        this.mesh.color=color;
        // this.mesh.physicsImpostor = new BABYLON.PhysicsImpostor(this.mesh, BABYLON.PhysicsImpostor.RopeImpostor, {fixedPoints: 3}, this.scene);
        // this.mesh.physicsImpostor.velocityIterations = 0; 
        // this.mesh.physicsImpostor.positionIterations = 5;
        // this.mesh.physicsImpostor.stiffness = 0.8; 
    }
    dispose(){
        //this.mesh.physicsImpostor.dispose();
        this.mesh.dispose();
        //this.scene=null;
        delete this;
    }

}

export class Dfy{
    constructor(scene,size,pos){
        this.eleall=[];
        this.scene=scene;
        this.model=[];
        this.camPos = BABYLON.Vector3.Zero();
        this.camTarget = BABYLON.Vector3.Zero();
        
        //let dfy=BABYLON.MeshBuilder.CreateBox("dfybody", {size: 5}, scene); 
        //dfy.scaling.x=1.5;

        let plus=BABYLON.MeshBuilder.CreateCylinder("+",{height:0.5},scene);
        plus.position=new BABYLON.Vector3(-2.5,2.5,1);
        plus.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let minus=BABYLON.MeshBuilder.CreateCylinder("-",{height:0.5},scene);
        minus.position=new BABYLON.Vector3(-2.5,2.5,-1);
        minus.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let dfy_screen=BABYLON.MeshBuilder.CreateBox("dfy_Screen", {size: 3}, scene);
        dfy_screen.rotationQuaternion=new BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0,1,0),Math.PI/2) ;
        //dfy_screen.scaling.y=0.1;
        dfy_screen.position=new BABYLON.Vector3(-0.4,2.29,0.07);
        dfy_screen.scaling=new BABYLON.Vector3(0.8,0.1,0.8);
        //dfy_screen.position.y=2.5;
        //dfy_screen.position.z=0.8;
        this.screen=new Screen(this.scene,this.canvas,dfy_screen,0.5);
        let plus_A=BABYLON.MeshBuilder.CreateCylinder("A",{height:0.5},scene);
        plus_A.position=new BABYLON.Vector3(3.1,2.5,-0.88);
        plus_A.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let plus_B=BABYLON.MeshBuilder.CreateCylinder("B",{height:0.5},scene);
        plus_B.position=new BABYLON.Vector3(3.1,2.5,-0.09);
        plus_B.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let plus_M=BABYLON.MeshBuilder.CreateCylinder("M",{height:0.5},scene);
        plus_M.position=new BABYLON.Vector3(3.1,2.5,0.75);
        plus_M.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let plus_N=BABYLON.MeshBuilder.CreateCylinder("N",{height:0.5},scene);
        plus_N.position=new BABYLON.Vector3(3.1,2.5,1.58);
        plus_N.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let dfy_all=BABYLON.MeshBuilder.CreateBox("dfy_all", {size:1}, scene);
        //dfy.parent=dfy_all;
        dfy_screen.parent=dfy_all;
        plus.parent=dfy_all;
        minus.parent=dfy_all;
        plus_A.parent=dfy_all;
        plus_B.parent=dfy_all;
        plus_M.parent=dfy_all;
        plus_N.parent=dfy_all;

        BABYLON.SceneLoader.ImportMesh("","/assets/models/dfy/","dfy.obj",this.scene, 
            (result)=> {
                let mat =new BABYLON.StandardMaterial("dfy.obj", this.scene);
                let diffuse=new BABYLON.Texture("/assets/models/dfy/dfy_texture.jpg", this.scene,true,false);
                let specular=new BABYLON.Texture("/assets/models/dfy/dfy_specular.jpg", this.scene,true,false);
                // diffuse.uScale = 1; 
                // diffuse.vScale = -1;
                // specular.uScale = -1; 
                // specular.vScale = -1;
                mat.diffuseTexture=diffuse; 
                mat.specularTexture=specular;
                result[1].material=mat;
                result[1].scaling=new BABYLON.Vector3(0.5,0.5,0.5);
                result[1].position.y=-2.5;
                //self.model=result[1];
                result[1].parent=dfy_all;
            }
        );

        let materialBox = new BABYLON.StandardMaterial("ele",this.scene);
        materialBox.diffuseColor=new BABYLON.Color3(1, 0, 0);
        materialBox.emissiveColor=new BABYLON.Color3(1, 0, 0);
        plus_A.material = materialBox;
        plus_B.material = materialBox;
        plus_M.material = materialBox;
        plus_N.material = materialBox;
        plus.material = materialBox;
        minus.material = materialBox;

        // modelloader("dfy.obj","/assets/models/dfy/","dfy_texture.jpg","dfy_specular.jpg",this,this.scene);
        // this.model.parent=dfy_all;
        this.mesh=dfy_all;
        this.plusA=plus_A;
        this.plusB=plus_B;
        this.plusM=plus_M;
        this.plusN=plus_N;
        this.plus=plus;
        this.minus=minus;

        if(size!==0 && pos!==0){
            dfy_all.scaling=new BABYLON.Vector3(size,size,size);
            dfy_all.position=pos;
        }
    }
}
export class Battery{
    constructor(scene,size,pos){
        this.scene=scene;
        //let bb=BABYLON.MeshBuilder.CreateBox("cb1", {size:5}, scene);
        //bb.scaling.z=0.5
        //
        
        //
        let holep=BABYLON.MeshBuilder.CreateCylinder("+",{height:0.5},scene);

        holep.position=new BABYLON.Vector3(0,2.5,0.8);

        let holem=BABYLON.MeshBuilder.CreateCylinder("-",{height:0.5},scene);
        holem.position=new BABYLON.Vector3(0,2.5,-0.8);

        //
        let bball=BABYLON.MeshBuilder.CreateBox("bball", {size:1}, scene);

        BABYLON.SceneLoader.ImportMesh("","/assets/models/dy/","dy.obj",this.scene, 
            (result)=> {
                let mat =new BABYLON.StandardMaterial("dy.obj", this.scene);
                let diffuse=new BABYLON.Texture("/assets/models/dy/dy_diffuse.jpg", this.scene,true,false);
                let specular=new BABYLON.Texture("/assets/models/dy/dy_specular.jpg", this.scene,true,false);
                // diffuse.uScale = 1; 
                // diffuse.vScale = -1;
                // specular.uScale = -1; 
                // specular.vScale = -1;
                mat.diffuseTexture=diffuse; 
                mat.specularTexture=specular;
                result[1].material=mat;
                //result[1].scaling=new BABYLON.Vector3(0.5,0.5,0.5);
                result[1].position.y=-2.5;
                //self.model=result[1];
                result[1].parent=bball;
            }
        );
      
        holep.parent=bball;
        holem.parent=bball;
        //bb.parent=bball;

        let materialBox = new BABYLON.StandardMaterial("ele",this.scene);
        materialBox.diffuseColor=new BABYLON.Color3(1, 0, 0);
        materialBox.emissiveColor=new BABYLON.Color3(1, 0, 0);
        holep.material = materialBox;
        holem.material = materialBox;

        this.mesh=bball;
        this.plus=holep;
        this.minus=holem;
        if(size!==0 && pos!==0){
            bball.scaling=new BABYLON.Vector3(size,size,size);
            bball.position=pos;
        }
    }

}

export class Zhy{
    constructor(scene,size,pos){
        //let dfy=BABYLON.MeshBuilder.CreateBox("zhybody", {size: 5}, scene); 
        

        //let plus=BABYLON.MeshBuilder.CreateCylinder("A",{height:0.5},scene);
        //plus.position=new BABYLON.Vector3(1,2.5,0);

        let plus_A=BABYLON.MeshBuilder.CreateCylinder("A",{height:0.5},scene);
        plus_A.position=new BABYLON.Vector3(2.4,2.5,-1.15);
        plus_A.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let plus_B=BABYLON.MeshBuilder.CreateCylinder("B",{height:0.5},scene);
        plus_B.position=new BABYLON.Vector3(2.4,2.5,-0.45);
        plus_B.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let plus_M=BABYLON.MeshBuilder.CreateCylinder("M",{height:0.5},scene);
        plus_M.position=new BABYLON.Vector3(2.4,2.5,0.25);
        plus_M.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let plus_N=BABYLON.MeshBuilder.CreateCylinder("N",{height:0.5},scene);
        plus_N.position=new BABYLON.Vector3(2.4,2.5,0.95);
        plus_N.scaling=new BABYLON.Vector3(0.5,0.5,0.5);
        let zhy_all=BABYLON.MeshBuilder.CreateBox("zhy_all", {size:1}, scene);

        let pa = BABYLON.MeshBuilder.CreateCylinder("1-30",{height:0.5},scene);
        pa.position = new BABYLON.Vector3(-2.53,2.58,0.81);
        pa.scaling.x=0.5;
        pa.scaling.z=0.5;
        let pb = BABYLON.MeshBuilder.CreateCylinder("31-60",{height:0.5},scene);
        pb.position = new BABYLON.Vector3(-2.53,2.58,-0.82);
        pb.scaling.x=0.5;
        pb.scaling.z=0.5;
        //dfy.parent=dfy_all;
        BABYLON.SceneLoader.ImportMesh("","/assets/models/zhy/","zhy.obj",this.scene, 
            (result)=> {
                let mat =new BABYLON.StandardMaterial("zhy.obj", this.scene);
                let diffuse=new BABYLON.Texture("/assets/models/zhy/zhy_diffuse.jpg", this.scene,true,false);
                let specular=new BABYLON.Texture("/assets/models/zhy/zhy_specular.jpg", this.scene,true,false);
                // diffuse.uScale = 1; 
                // diffuse.vScale = -1;
                // specular.uScale = -1; 
                // specular.vScale = -1;
                mat.diffuseTexture=diffuse; 
                mat.specularTexture=specular;
                result[1].material=mat;
                //result[1].scaling=new BABYLON.Vector3(0.5,0.5,0.5);
                result[1].position.y=-2.5;
                //self.model=result[1];
                result[1].parent=zhy_all;
            }
        );
        plus_A.parent=zhy_all;
        plus_B.parent=zhy_all;
        plus_M.parent=zhy_all;
        plus_N.parent=zhy_all;

        pa.parent=zhy_all;
        pb.parent=zhy_all;
        //plus.parent=dfy_all;
        zhy_all.scaling=new BABYLON.Vector3(size,size,size);
        zhy_all.position=pos;

        let materialBox = new BABYLON.StandardMaterial("ele",this.scene);
        materialBox.diffuseColor=new BABYLON.Color3(1, 0, 0);
        materialBox.emissiveColor=new BABYLON.Color3(1, 0, 0);
        plus_A.material = materialBox;
        plus_B.material = materialBox;
        plus_M.material = materialBox;
        plus_N.material = materialBox;

        this.mesh=zhy_all;
        this.plusA=plus_A;
        this.plusB=plus_B;
        this.plusM=plus_M;
        this.plusN=plus_N;

        this.pa = pa;
        this.pb = pb;
    }
}

export class Screen{
    constructor(scene,canvas,mesh,size){
        this.scene=scene;
        this.canvas=canvas;
        this.state="";
        //this.text=[["1.start","2.middle","3.end","4.","5.","6.","7.","8.","9."],
        //["1."],["2."],["3."],["4."],["5."],["6."],["7."],["8."],["9."]];
        this.menu=dfy_menu;
        this.text = [];
        this.textureGround=new BABYLON.DynamicTexture("dynamic texture", {width:512, height:512}, scene); 
        this.mesh=mesh;
        this.camPos=new BABYLON.Vector3.Zero();
        this.camTarget=new BABYLON.Vector3.Zero();
        this.manager = new GUI.GUI3DManager(this.scene);
        this.panel = new GUI.PlanePanel();
        this.manager.addControl(this.panel);
        this.buttons = [];
        this.initScreen();
        this.initControlPad2(size);
        this.observer=null;
        this.inputMode = false;
        this.inputText = "";
        this.inputLocation =0;
        this.open = false;
        this.buttonsCanPress = "";
    }
    initScreen(){
        //Create dynamic texture
        //this.state.push(0);
        let textureResolution = 512;
        let textureGround = new BABYLON.DynamicTexture("dynamic texture", {width:textureResolution, height:textureResolution}, this.scene);   
        //let textureContext = textureGround.getContext();

        this.textureGround=textureGround;

        let materialGround = new BABYLON.StandardMaterial("Mat", this.scene);    				
        materialGround.diffuseTexture = textureGround;
        this.mesh.material = materialGround;

        //Add text to dynamic texture
        //let font = "bold 44px monospace";
        //textureGround.drawText("Grass", 75, 135, font, "green", "white", true, true);
        //let text=["1.start","2.middle","3.end","4.","5.","6.","7.","8.","9."];
        this.displayText([""]);
    }
    displayText(text){
        //console.log(text[1].length);
        let font = "bold 40px monospace";
        this.textureGround.drawText("", 75, 135, font, "black", "#8bac0f", true, true);
        //console.log(length);
        for(let i = 0;i<text.length;i++){
            this.textureGround.drawText(text[i], 75, 135+(i*44), font, "black", "transparent", true, true);
        }
        
    }
    initControlPad(size){
        let keyboardmesh=BABYLON.MeshBuilder.CreateBox("keyboard",{size:0.1},this.scene);
        //keyboardmesh.position.x+=1.1;
        //keyboardmesh.position.z+=1.1;
        let keyboard=[]
        for(let i=0; i <9 ; i++){
            let cube=BABYLON.MeshBuilder.CreateBox(""+i,{size:1},this.scene);
            //cube.position.x+=1.5;
            if(i>0&&i<3){
                cube.position.z+=1.1*i;
            }
            else if(i>=3&&i<6){
                cube.position.z+=1.1*(i%3);
                cube.position.x+=1.1;
            }
            else if(i>=6){
                cube.position.z+=1.1*(i%3);
                cube.position.x+=1.1*2;
            }
            //let textureResolution = 8;
            let textureGround = new BABYLON.DynamicTexture("dynamic texture"+i, {width:16, height:16}, this.scene);   
            //let textureContext = textureGround.getContext();
            //let materialGround=new BABYLON.Material("Mat",scene);
            let materialGround = new BABYLON.StandardMaterial("Mat", this.scene);    				
            materialGround.diffuseTexture = textureGround;
            cube.material = materialGround;
    
            //Add text to dynamic texture
            let font = "bold 14px monospace";
            textureGround.drawText(""+(i+1), 5, 13, font, "gray", "blue", true, true);
            cube.parent=keyboardmesh;
            keyboard.push(cube);
        }
        let undoKey=BABYLON.MeshBuilder.CreateBox("undo",{size:1},this.scene);
        undoKey.position=new BABYLON.Vector3(-1.1,0,2.2);
        undoKey.parent=keyboardmesh;
        let textureGround = new BABYLON.DynamicTexture("dynamic texture", {width:16, height:16}, this.scene);   
        
        let materialGround = new BABYLON.StandardMaterial("Mat", this.scene);    				
        
        //Add text to dynamic texture
        let font = "bold 7px monospace";
        textureGround.drawText("取消", 0, 13, font, "gray", "blue", true, true);
        materialGround.diffuseTexture = textureGround;
        undoKey.material = materialGround;

        keyboard.push(undoKey);
        //keyboardmesh.position.x=1.8;
        keyboardmesh.position=new BABYLON.Vector3(-0.26,0.75,1.96);
        keyboardmesh.scaling=new BABYLON.Vector3(size,size,size);
        //keyboardmesh.rotationQuaternion=new BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0,1,0),Math.PI/2 );
        keyboardmesh.parent=this.mesh;
    }
    initControlPad2(szie){
        let keyword = ["0","+/-",".","确认","1","2","3","退出","4/←","5/↓","6/→","清除","7","8/↑","9","功能","开","","","关"];
        this.panel.margin = 0.02;
        this.panel.columns = 4;
        //this.panel.rows = 3;
        this.panel.blockLayout = true;
        for (let index = 0; index < 20; index++) {
            let button = new GUI.Button3D(keyword[index]);
            this.panel.addControl(button);
            let text1 = new GUI.TextBlock();
            text1.text = keyword[index];
            text1.color = "white";
            text1.fontSize = 100;
            button.content = text1;
            button.mesh.material.disableLighting = true;
            this.buttons.push(button);
        }
        //this.buttons[17].dispose();
        //this.buttons[18].dispose();
        this.panel.blockLayout = false;
        this.panel.position=new BABYLON.Vector3(0,0.75,2.60);
        this.panel.node.rotation.x += Math.PI / 2;
        this.panel.node.rotation.z += Math.PI / 2;
        this.panel.scaling = new BABYLON.Vector3(szie-0.1, szie-0.1, szie-0.1);
        this.panel.node.parent = this.mesh;

        this.buttonsCanPress = "00000100000000000000";
        //console.log(this.buttonsCanPress);
    }
    butFunc_0(){
        this.buttons[0].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("0");
            if(this.inputMode){
                //this.inputText+="0";
                this.text[this.inputLocation]+="0";
            }
            else{
                this.state+="00";
                
            }
        });
    }
    butFunc_plus_minus(){
        let num = 0;
        let number = ["-10"," -5"," -2"," -1","  0"," +1"," +2"," +5","+10"];
        let disNumber = ["-1"," 0"," 1"];
        let dnum = 0;
        let curveRef = ["SP", "Ro", "M1", "M2", "M3", "M4", "M5", "M6", "M7", "TH", " D"]
        let cnum = 0;
        this.buttons[1].onPointerClickObservable.add(()=>{
            // if(this.open == false){
            //     return;
            // }
            if(this.state === "16150406"){
                let str1 = this.text[this.inputLocation].substring(0,this.text[this.inputLocation].length-3);
                this.text[this.inputLocation] = str1 + number[num]; 
                num++;
                if(num >= 9){
                    num=0;
                }
            }
            if(this.state === "1615040603"){
                let str1 = this.text[this.inputLocation].substring(0,this.text[this.inputLocation].length-2);
                this.text[this.inputLocation] = str1 + disNumber[dnum]; 
                dnum++;
                if(dnum >= 3){
                    dnum=0;
                }
            }
            if(this.state === "161504060303"){
                let str1 = this.text[this.inputLocation].substring(0,this.text[this.inputLocation].length-2);
                this.text[this.inputLocation] = str1 + curveRef[cnum]; 
                cnum++;
                if(cnum >= 11){
                    cnum=0;
                }
            }
            console.log("+/-");
            if(this.state === "16150505" || this.state === "1615050501" || this.state === "1615090303" || this.state === "161509030301"){
                this.state+="01";
            }
            //
        });
    }
    butFunc__dot(){
        this.buttons[2].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log(".");
            this.state+="02";
        });
    }
    butFunc_confirm(){
        this.buttons[3].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("confirm");
            this.state+="03";
        });
    }
    butFunc_1(){
        this.buttons[4].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("1");
            if(this.inputMode){
                this.text[this.inputLocation]+="1";
            }
            else{
                this.state+="04";
            }
        });
    }
    butFunc_2(){
        this.buttons[5].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("2");
            if(this.inputMode){
                this.text[this.inputLocation]+="2";
            }
            else{
                this.state+="05";
                //console.log(this.buttonsCanPress.substring(0,0));
            }
        });
    }
    butFunc_3(){
        this.buttons[6].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("3");
            if(this.inputMode){
                this.text[this.inputLocation]+="3";
            }
            else{
                this.state+="06";
            }
        });
    }
    butFunc_exit(){
        this.buttons[7].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("exit");
            if(this.state === "16"){
                return;
            }
            let str1 = this.state.substring(0,this.state.length-1);
            this.state = str1.substring(0,str1.length-1);
            console.log(this.state);
        });
    }
    butFunc_4(){
        this.buttons[8].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("4");
            if(this.inputMode){
                this.text[this.inputLocation]+="4";
            }
            else{
                this.state+="08";
            }
        });
    }
    butFunc_5(){
        this.buttons[9].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("5");
            if(this.inputMode){
                this.text[this.inputLocation]+="5";
            }
            else{
                this.state+="09";
            }
        });
    }
    butFunc_6(){
        this.buttons[10].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("6");
            if(this.inputMode){
                this.text[this.inputLocation]+="6";
            }
            else{
                this.state+="10";
            }
        });
    }
    butFunc_clean(){
        this.buttons[11].onPointerClickObservable.add(()=>{
            if(this.open === false){
                return;
            }
            console.log("clean");
        });
    }
    butFunc_7(){
        this.buttons[12].onPointerClickObservable.add(()=>{
            console.log("7");
            if(this.open === false){
                return;
            }
            if(this.inputMode){
                this.text[this.inputLocation]+="7";
            }
            else{
                this.state+="12";
            }
        });
    }
    butFunc_8(){
        this.buttons[13].onPointerClickObservable.add(()=>{
            console.log("8");
            if(this.open === false){
                return;
            }
            if(this.inputMode){
                this.text[this.inputLocation]+="8";
            }
            else{
                this.state+="13";
            }
        });
    }
    butFunc_9(){
        this.buttons[14].onPointerClickObservable.add(()=>{
            console.log("9");
            if(this.open === false){
                return;
            }
            if(this.inputMode){
                this.text[this.inputLocation]+="9";
            }
            else{
                this.state+="14";
            }
        });
    }
    butFunc_func(){
        this.buttons[15].onPointerClickObservable.add(()=>{
            // if(this.open == false){
            //     return;
            // }
            console.log("func");
            this.state+="15";
        });
    }
    
    butFunc_powerOff(){
        this.buttons[19].onPointerClickObservable.add(()=>{
            console.log("off");
            this.state = "";
            this.inputMode = false;
            this.inputText = [""];
            this.displayText([""]);
            //this.disposeButtonObserver()
            this.scene.onBeforeRenderObservable.remove(this.observer);
            this.open = false;
        });
    }

    butFunc_powerOn(){   
        this.buttons[16].onPointerClickObservable.add(()=>{
            if(this.state !== ""){
                if(this.state.substr(0,2) === "16"){
                    alert("已经开机了！");
                    return;
                }
            }
            
            this.state = "";
            console.log("on");
            this.state+="16";
            //this.displayText(this.menu[0]);
            this.text=this.menu[0];

            

            this.observer = this.scene.onBeforeRenderObservable.add(()=>{
               
                //this.text = this.menu[0];
                switch(this.state){
                    //主功能菜单
                    case "1615":
                        this.text = this.menu[1];
                        this.inputMode = false;
                        this.open = true;
                        this.displayText(this.text);
                        break;
                    //设置工作参数
                    case "161504":
                        this.inputMode = false;
                        this.text = this.menu[5];
                        this.displayText(this.text);
                        break;
                    //1.1工作测线与装置
                    case "16150404":
                        this.text = this.menu[8];
                        this.inputMode = true;
                        this.inputLocation = 2;
                        this.displayText(this.text);
                        break;
                    //输入第一个参数
                    case "1615040403":
                        this.inputLocation=3;
                        this.displayText(this.text);
                        break;
                    //输入第二个参数
                    case "161504040303":
                        this.inputMode = false;
                        this.text = this.menu[9];
                        this.displayText(this.text);
                        break;
                    //1.2供电与采样参数
                    case "16150405":
                        this.text = this.menu[10];
                        this.displayText(this.text);
                        this.inputMode = true;
                        this.inputLocation = 0;
                        break;
                    //输入参数
                    case "1615040503":
                        //this.inputLocation = [1];
                        this.inputMode = false;
                        this.state = "161504";
                        break;
                    //1.3增量参数
                    case "16150406":
                        this.text = this.menu[11];
                        this.displayText(this.text);
                        this.inputLocation = 0;
                        //this.open = false;
                        break;
                    case "1615040603":
                        this.inputLocation = 1;
                        this.displayText(this.text);
                        break;
                    case "161504060303":
                        this.inputLocation = 2;
                        this.displayText(this.text);
                        break;
                    case "16150406030303":
                        this.inputMode = false;
                        this.state = "1615";
                        this.inputLocation = 0;
                        break;
                    //2.测量
                    case "161505":
                        this.inputMode = false;
                        this.text = this.menu[6];
                        this.displayText(this.text);
                        break;
                    //2.1自电Sp
                    case "16150504":
                        this.text = this.menu[13];
                        //setInterval(()=>{this.state = "161505";},3000);
                        this.displayText(this.text);
                        break;
                    //2.2电阻率与自电
                    case "16150505":
                        this.text = this.menu[14];
                        this.displayText(this.text);
                        break;
                    case "1615050501":
                        this.text = this.menu[15];
                        this.displayText(this.text);
                        break;
                    case "161505050101":
                        this.state = "16150505";
                        break;
                    case "1615050503":
                        this.text = this.menu[16];
                        this.displayText(this.text);
                        break;
                    case "161505050103":
                        this.text = this.menu[16];
                        this.displayText(this.text);
                        break;
                    //2.3电池电压
                    case "16150506":
                        this.text = this.menu[17];
                        this.displayText(this.text);
                        break;
                    //2.4计算器
                    case "16150508":
                        this.text = this.menu[18];
                        this.displayText(this.text);
                        break;
                    //2.5输入极距常数
                    case "16150509":
                        this.text = this.menu[19];
                        this.inputLocation = 0;
                        this.inputMode = true;
                        this.displayText(this.text);
                        break;
                    //2.6接地电阻
                    case "16150510":
                        this.text = this.menu[20];
                        this.displayText(this.text);
                        break;
                    case "1615051003" || "1615050903" || "16150505010303":
                        this.state = "161505";
                        break;
                    //3测线表
                    case "161506":
                        this.inputMode = false;
                        this.text = this.menu[21];
                        this.displayText(this.text);
                        break;
                    //4显示曲线
                    case "161508":
                        this.inputMode = true;
                        this.inputLocation = 2;
                        this.text = this.menu[22];
                        this.displayText(this.text);
                        break;
                    case "16150803":
                        this.inputMode = true;
                        this.inputLocation = 3;
                        this.text = this.menu[22];
                        this.displayText(this.text);
                        break;
                    case "1615080303":
                        this.inputMode = false;
                        this.inputLocation = 0;
                        this.text = this.menu[23];
                        this.displayText(this.text);
                        break;
                    //5显示数据
                    case "161509":
                        this.inputMode = true;
                        this.inputLocation = 2;
                        this.text = this.menu[24];
                        this.displayText(this.text);
                        break;
                    case "16150903":
                        this.inputMode = true;
                        this.inputLocation = 3;
                        this.text = this.menu[24];
                        this.displayText(this.text);
                        break;
                    case "1615090303":
                        this.inputMode = false;
                        this.inputLocation = 0;
                        this.text = this.menu[25];
                        this.displayText(this.text);
                        break;
                    case "161509030301":
                        this.text = this.menu[26];
                        this.displayText(this.text);
                        break;
                    case "16150903030101":
                        this.state = "1615090303";
                        break;
                    //6 RS232通讯
                    case "161510":
                        this.inputMode = false;
                        this.inputLocation = 0;
                        this.text = this.menu[27];
                        this.displayText(this.text);
                        break;
                    //7硬件测试
                    case "161512":
                        this.inputMode = false;
                        this.inputLocation = 0;
                        this.text = this.menu[28];
                        this.displayText(this.text);
                        break;
                    case "16151003" || "16151203" ||  "161509030303" || "16150903030103" || "161508030303" || "16150603":
                        this.state = "1615";
                        break;
                    default:
                        this.displayText(this.text);
                        break;
                    
                }
            });
        });
    }
    activeControlPad(){
        let firstHit=true;
        let state=0;
        this.observer=this.scene.onPointerObservable.add((pointerInfo) => {
        let pickInfo = this.scene.pick(this.scene.pointerX, this.scene.pointerY);
        
        if (pointerInfo.type === BABYLON.PointerEventTypes.POINTERDOWN) {
            console.log("press");
            if(pickInfo.hit){
                console.log(pickInfo.pickedMesh.name);
                if(parseInt(pickInfo.pickedMesh.name)>=0 && parseInt(pickInfo.pickedMesh.name)<9){
                    console.log(parseInt(pickInfo.pickedMesh.name));
                    if(firstHit === true){
                        state=0;
                        firstHit=false;
                    }
                    else{
                        state=(parseInt(pickInfo.pickedMesh.name)+1);
                    }
                    this.state.push(state);
                    
                    //screen.displayText(["you choosed "+(screen.state[screen.state.length-1]+1)]);
                    this.displayText(this.text[0][this.state[this.state.length-1]]);
                }
                else if(pickInfo.pickedMesh.name === "undo"){
                    if(this.state.length>1){
                        this.state.pop();
                        this.displayText(this.text[0][this.state[this.state.length-1]]);
                        console.log(this.state);
                        //screen.displayText(["you last choosed "+(screen.state[screen.state.length-1]+1)]);
                    }
                    
                }
            }
        }	
    });
    }
    activeControlPad2(){
        
        this.butFunc_powerOn();
        this.butFunc_0();
        this.butFunc_1();
        this.butFunc_2();
        this.butFunc_3();
        this.butFunc_4();
        this.butFunc_5();
        this.butFunc_6();
        this.butFunc_7();
        this.butFunc_8();
        this.butFunc_9();
        this.butFunc_clean();
        this.butFunc_confirm();
        this.butFunc_func();
        this.butFunc_plus_minus();
        this.butFunc__dot();
        this.butFunc_exit();
        this.butFunc_powerOff();

        
    }
    disposeButtonObserver(){
        for(let i = 0 ;i < this.buttons.length ; i++){
            if(i === 16){
                continue;
            }
            this.buttons[i].onPointerClickObservable.clear();
        }
    }
    disposeControlPad(){
        if(this.observer!==null){
            this.scene.onPointerObservable.remove(this.observer);
        }
        
    }
    createTextTexture(text,mesh){
        let textureGround = new BABYLON.DynamicTexture("dynamic texture", {width:16, height:16}, this.scene);   
        
        let materialGround = new BABYLON.StandardMaterial("Mat", this.scene);    				
        
        
        
        //Add text to dynamic texture
        let font = "bold 14px monospace";
        textureGround.drawText(text, 75, 135, font, "green", "white", true, true);
        materialGround.diffuseTexture = textureGround;
        mesh.material = materialGround;
        
    }
}
